import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSelectModule } from '@angular/material/select';

import { SharedRoutingModule } from './shared-routing.module';
import { LoadingComponent } from './loading/loading.component';
import { SnackBarComponent } from './snack-bar/snack-bar.component';
import { DialogComponent } from './dialog/dialog.component';
import { FilterModule } from './pipe/filter/filter.module';
import { PrintPageComponent } from './print-page/print-page.component';
import { PrintPurchaseComponent } from './print-purchase/print-purchase.component';
import { TranslateModule } from '@ngx-translate/core';
import { DeleteAccComponent } from './delete-acc/delete-acc.component';

@NgModule({
  declarations: [
    LoadingComponent,
    SnackBarComponent,
    DialogComponent,
    PrintPageComponent,
    PrintPurchaseComponent,
    DeleteAccComponent
  ],
  imports: [
    CommonModule,
    SharedRoutingModule,
    MatToolbarModule,
    MatIconModule,
    MatSidenavModule,
    MatExpansionModule,
    FilterModule,
    MatSelectModule,
    TranslateModule
  ],
  exports: [LoadingComponent, FilterModule]
})
export class SharedModule {}
